import { IResponse } from '../../common/model/Core.model'
import { environment } from '../../util/Environment'
import { apiSlice } from '../store/Api'
import { IReportCreateRequestDto, IReportDownloadRequestDto, IReportDownloadResponseDto, IReportDto, IReportSearchRequestDto, IReportShareRequestDto, IReportUpdateRequestDto } from './Report.model'

export const reportApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      reportAttachmentSearch: builder.mutation<IResponse, IReportSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/attachment/search`,
            method: 'POST',
            body,
          }
        },
      }),
      reportAttachmentDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.report}/attachment/${id}`,
            method: 'DELETE',
          }
        },
      }),
      reportTicketAttachmentSearch: builder.mutation<IResponse, IReportSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/ticket/attachment/search`,
            method: 'POST',
            body,
          }
        },
      }),
      reportTicketAttachmentDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.report}/ticket/attachment/${id}`,
            method: 'DELETE',
          }
        },
      }),
      reportSearch: builder.mutation<IResponse, IReportSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      reportLoadMore: builder.mutation<IResponse, IReportSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      reportGetById: builder.mutation<IReportDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.report}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      reportDeleteById: builder.mutation<IReportDto, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.report}/${id}`,
            method: 'DELETE',
          }
        },
      }),
      reportUpdateById: builder.mutation<IReportDto, IReportUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      reportCreate: builder.mutation<IReportDto, IReportCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}`,
            method: 'POST',
            body,
          }
        },
      }),
      reportDowloadById: builder.mutation<IReportDownloadResponseDto, IReportDownloadRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/export`,
            method: 'POST',
            body,
          }
        },
      }),
      reportDowloadAcceptanceById: builder.mutation<
        IReportDownloadResponseDto,
        IReportDownloadRequestDto
      >({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/export`,
            method: 'POST',
            body,
          }
        },
      }),
      reportShareById: builder.mutation<void, IReportShareRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/share`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useReportAttachmentSearchMutation,
  useReportAttachmentDeleteByIdMutation,
  useReportTicketAttachmentSearchMutation,
  useReportTicketAttachmentDeleteByIdMutation,
  useReportSearchMutation,
  useReportLoadMoreMutation,
  useReportGetByIdMutation,
  useReportDeleteByIdMutation,
  useReportUpdateByIdMutation,
  useReportCreateMutation,
  useReportDowloadByIdMutation,
  useReportDowloadAcceptanceByIdMutation,
  useReportShareByIdMutation,
} = reportApi
